import { render, staticRenderFns } from "./PaperMaterialEdit.vue?vue&type=template&id=77f6cc5d&"
import script from "./PaperMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./PaperMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports